import {
  Swiper,
  Navigation,
  Pagination,
  Scrollbar,
  Autoplay,
  Lazy,
  EffectFade,
  FreeMode,
  Manipulation,
  Thumbs,
} from 'swiper';

Swiper.use([
  Navigation,
  Pagination,
  Scrollbar,
  EffectFade,
  Autoplay,
  Lazy,
  FreeMode,
  Manipulation,
  Thumbs,
]);

//Swiper2.extendDefaults({});

window.Swiper = Swiper;
